import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import TaskEditDialog from '../Dialogs/TaskEditDialog';
import {AuditLog} from '../../Api/AuditTypes';

type AuditLogRow = {
    data: AuditLog;
}

type Props = {
    rowData: AuditLogRow[];
}

/** */
type State = {
    filters: MTableFilters;
}

class AuditListControl extends MComponent<Props, State> {

    private readonly m_editRef: RefObject<TaskEditDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_editRef = createRef<TaskEditDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private entryDateTemplate(rowData: AuditLogRow): string | undefined {
        if(rowData.data.entryDate !== null) {
            try {
                return rowData.data.entryDate!.toLocaleString();
            } catch {
                return '';
            }
        }
        return '';
    }
    public render(): ReactElement {
        return (
            <React.Fragment>
                <TaskEditDialog ref={this.m_editRef}/>
                <MTable
                    rowKey="data.safeDigTasksId"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    sortField={'data.entryDate'}
                    sortOrder={-1}>

                    <Column field="data.entryDate"
                            header="Date"
                            body={this.entryDateTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '30%'}}/>
                    <Column field="data.userName"
                            header="User"
                            filter={false}
                            sortable={true}
                            style={{width: '35%'}}/>
                    <Column field="data.notes"
                            header="Action"
                            filter={false}
                            sortable={false}
                            style={{width: '35%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default AuditListControl;